lmApp
  .service('ValidatorService', [
    function () {
      var service = {};

      var usernameRegExp = /^[a-z0-9_-]{3,16}$/;
      var emailRegExp = /^[а-яА-ЯёЁA-Za-z0-9\.\+_-]+@[а-яА-ЯёЁA-Za-z0-9\._-]+\.[а-яА-ЯёЁa-zA-Z]{2,4}$/;
      var urlRegExp = /^([a-z][a-z0-9\*\-\.]*):\/\/(?:(?:(?:[\w\.\-\+!$&'\(\)*\+,;=]|%[0-9a-f]{2})+:)*(?:[\w\.\-\+%!$&'\(\)*\+,;=]|%[0-9a-f]{2})+@)?(?:(?:[a-z0-9\-\.]|%[0-9a-f]{2})+|(?:\[(?:[0-9a-f]{0,4}:)*(?:[0-9a-f]{0,4})\]))(?::[0-9]+)?(?:[\/|\?](?:[\w#!:\.\?\+=&@!$'~*,;\/\(\)\[\]\-]|%[0-9a-f]{2})*)?$/;
      var passwordRegExp = /^.{6,50}$/;
      var youtubeChannelRegExp = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com)\/channel\/(.*)$/;
      var youtubeUserRegExp = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com)\/user\/(.*)$/;
      var youtubeVideoRegExp = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))(.*)$/;
      var lettersReplace = /\D+/g;
      var numerical = /^[0-9]+$/;
      var pinRegExp = /^[0-9]{4}$/;
      var ipAddressWithMaskRegExp = /^([1-9]|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])(\.(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])){3}\/\d{1,2}$/;
      var ipAddressRegExp = /^([1-9]|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])(\.(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])){3}$/;

      service.youtubeChannelRegExp = youtubeChannelRegExp;
      service.youtubeUserRegExp = youtubeUserRegExp;
      service.youtubeVideoRegExp = youtubeVideoRegExp;

      service.Username = function (value) {
        return usernameRegExp.test(value.toString());
      };

      service.Email = function (value) {
        return emailRegExp.test(value.toString());
      };

      service.Url = function (value) {
        return urlRegExp.test(value.toString());
      };

      service.Password = function (value) {
        return passwordRegExp.test(value.toString());
      };

      service.YoutubeChannel = function (value) {
        return youtubeChannelRegExp.test(value.toString());
      };

      service.YoutubeUser = function (value) {
        return youtubeUserRegExp.test(value.toString());
      };

      service.YoutubeVideo = function (value) {
        return youtubeVideoRegExp.test(value.toString());
      };

      service.Numerical = function (value) {
        return !_.isArray(value) && (value - parseFloat(value) + 1) >= 0;
      };

      service.Undefined = function (value) {
        return _.isUndefined(value);
      };

      service.Logical = function (value) {
        return _.isBoolean(value);
      };

      service.Pin = function (value) {
        return pinRegExp.test(value.toString());
      };

      service.IPWithMask = function(value) {
        return ipAddressWithMaskRegExp.test(value.toString());
      };

      service.IP = function(value) {
        return ipAddressRegExp.test(value.toString());
      };

      return service;
    }]);
